export const promote = (config) => ({
    ...config
    // optional `tags` field added, existing v4 configs just have tags as empty after promotion.
});
//# sourceMappingURL=zendesk-create-ticket-4-to-5.js.map